import type { DelayPair } from './types';
import { clampU16 } from './delay';
import { pngChunkCrc } from './crc32';
import { iterPngChunks } from './png-chunks';

/**
 * 按顺序改写每个 fcTL 的 delay_num/delay_den，可选 patch acTL.num_plays，重算 CRC。
 */
export function patchApngFrameDelays(
  input: Uint8Array,
  delays: DelayPair[],
  numPlays?: number,
): Uint8Array {
  const buf = new Uint8Array(input);
  const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
  const delayList = delays.map(([n, d]) => [clampU16(n), clampU16(d)] as const);

  let fctlI = 0;
  let actlPatched = false;

  for (const chunk of iterPngChunks(buf)) {
    if (chunk.type === 'acTL' && numPlays !== undefined && chunk.length >= 8) {
      view.setUint32(chunk.dataStart + 4, numPlays >>> 0);
      const data = buf.subarray(chunk.dataStart, chunk.dataEnd);
      const crc = pngChunkCrc(chunk.typeBytes, data);
      view.setUint32(chunk.crcOffset, crc);
      actlPatched = true;
    } else if (chunk.type === 'fcTL' && chunk.length >= 26) {
      if (fctlI >= delayList.length) {
        fctlI += 1;
        continue;
      }
      const [num, den] = delayList[fctlI]!;
      view.setUint16(chunk.dataStart + 20, num);
      view.setUint16(chunk.dataStart + 22, den);
      const data = buf.subarray(chunk.dataStart, chunk.dataEnd);
      const crc = pngChunkCrc(chunk.typeBytes, data);
      view.setUint32(chunk.crcOffset, crc);
      fctlI += 1;
    }
  }

  if (fctlI < delayList.length) {
    throw new Error(
      `APNG 仅有 ${fctlI} 个 fcTL，但提供了 ${delayList.length} 组 delay`,
    );
  }
  if (numPlays !== undefined && !actlPatched) {
    // 无 acTL 时无法设置 loop；双帧 APNG 应总有 acTL
  }

  return buf;
}
